export const isFromCalenderError = (fromYear: number | null, fromMonth: string | null) => {
	const currentTime = new Date();
	const year = currentTime.getFullYear();
	const month = currentTime.getMonth() + 1;
	if (fromYear?.toString() === year.toString()) {
		if (Number(fromMonth) > Number(month)) {
			return true;
		}
	}
	return false;
};

export const isToCalenderError = (fromYear: number | null, toMonth: string | null, fromMonth: string | null) => {
	const currentTime = new Date();
	const year = currentTime.getFullYear();
	const month = currentTime.getMonth() + 1;
	if (fromYear?.toString() === year.toString()) {
		if (Number(fromMonth) === Number(month) && Number(toMonth) > Number(fromMonth)) {
			return true;
		}
	}
	return false;
};
